export function sendErrorReportViaEMail(errorStack, componentStack) {
	const versionInfo = window.document.getElementById('evoAppsVersionInfo').innerText
	window.open('mailto:evo-bugreport@sisworld.com?subject=Fehler in SIS-evoApps&body=' + encodeURIComponent(`
Hallo!
Es ist ein Fehler in evoApps aufgetreten.

	
Bitte folgende Fragen ausfüllen:

- Wie ist der Fehler aufgetreten (Klick auf ..., Eingabe von ..., etc.)?


- Mit welchem Benutzer ist der Fehler aufgetreten?


- Ist der Fehler wiederholbar?


- Weitere Anmerkungen?


Vielen Dank!


________________________

Informationen für die Entwickler:

________________________
Versionsinformationen:
${versionInfo}
________________________

${errorStack}

________________________

${componentStack}

________________________

`))
}